<template>
  <div id="alterations">
    <div class="header flex-between">
      <div class="header-text">
        <h1>会员开源开散</h1>
      </div>
      <div class="header-button">
        <el-button
          v-if="jurisdiction.search"
          icon="iconfont icon-sousuo1"
          @click="search"
          >查询</el-button
        >
        <el-button @click="eliminate">清除查询条件</el-button>
        <el-button v-if="jurisdiction.export" @click="exportShow = true"
          >导出</el-button
        >
        <el-button
          v-if="jurisdiction.export"
          @click="(downloadShow = true), getDownladList()"
          >下载</el-button
        >
      </div>
    </div>
    <!-- 首页查询card -->
    <el-card shadow="never">
      <div class="searchform">
        <el-form label-width="100px" :model="queryInfo" size="small">
          <el-row>
            <el-col :span="12">
              <el-form-item label="区域">
                <el-select
                  v-model="queryInfo.regionIds"
                  multiple
                  style="width: 50%"
                >
                  <el-option
                    v-for="item in regionList"
                    :key="item.id"
                    :label="item.lable"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-col>
                <el-form-item label="时间段单位" prop="timeUnit">
                  <el-radio-group
                    id="radiof"
                    style="width: 50%"
                    v-model="queryInfo.timeUnit"
                  >
                    <el-radio label="0">年</el-radio>
                    <el-radio label="1">月</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="从">
                  <el-date-picker
                    style="width: 50%"
                    v-model="queryInfo.datePicker"
                    type="daterange"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="12">
              <el-col :span="16">
                <el-form-item label="门店" prop="listOfSomeStoreslStr">
                  <textarea
                    style="width: 85%"
                    rows="6"
                    readonly
                    v-model="queryInfo.listOfSomeStoreslStr"
                  ></textarea>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-button style="margin-left: -30px" @click="xuanzemendian"
                  >选择门店</el-button
                >
              </el-col>
            </el-col>
          </el-row>
          <!-- <el-divider></el-divider>
          <div class="demo-input-suffix">
            <div class="JfNumber-flex" style="margin-left: 50px">
              <p>总记录数</p>
              <p class="integrate-number">{{ cntAll }}</p>
            </div>
            <div class="JfNumber-flex">
              <p>总开源人数</p>
              <p class="integrate-number">{{ cntAllKY }}</p>
            </div>
            <div class="JfNumber-flex">
              <p>总开散人数</p>
              <p class="integrate-number">
                {{ cntAllKS }}
              </p>
            </div>
          </div> -->
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never" :body-style="bodyStyle">
      <div style="padding: 10px 0px 0px 10px">
        <el-form
          :model="queryInfojl"
          size="small"
          :inline="true"
          label-position="left"
        >
          <el-form-item label="总人数">
            <el-input
              readonly
              :value="toThousands(queryInfojl.cntAll)"
            ></el-input>
          </el-form-item>
          <el-form-item label="总开源人数">
            <el-input
              readonly
              :value="toThousands(queryInfojl.cntAllKY)"
            ></el-input>
          </el-form-item>
          <el-form-item label="总开散人数">
            <el-input
              readonly
              :value="toThousands(queryInfojl.cntAllKS)"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <div>
      <!-- 首页列表内容 -->
      <el-card shadow="never" class="centercard">
        <el-table
          size="small"
          class="table-style"
          :height="isMore ? 'calc(100vh - 34.3rem)' : 'calc(100vh - 32.5rem)'"
          border
          :row-class-name="tableRowClassName"
          :header-cell-style="{
            background: '#FCFBF2',
            color: '#6C6839',
            'text-align': 'center',
            fontSize: '14px',
          }"
          :cell-style="{ 'text-align': 'center' }"
          ref="multipleTable"
          :data="ActionroleqxList"
          tooltip-effect="dark"
          v-el-table-infinite-scroll="load"
          v-loading="loading"
          infinite-scroll-disabled="onLoading"
        >
          <!-- <el-table-column type="selection" width="45"> </el-table-column> -->
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column prop="RegionName" label="区域"> </el-table-column>
          <el-table-column prop="ShopCode" label="门店编码"> </el-table-column>
          <el-table-column prop="ShopName" label="门店名称"> </el-table-column>
          <el-table-column
            :label="item"
            v-for="(item, index) in yearstable"
            :key="index"
          >
            <el-table-column label="开源人数">
              <template slot-scope="scope">
                {{ scope.row.staticData[index].kaiYuan }}
              </template>
            </el-table-column>
            <el-table-column label="开散人数">
              <template slot-scope="scope">
                {{ scope.row.staticData[index].kaiSan }}
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
        <el-alert
          v-if="isMore"
          title="没有更多啦!"
          type="warning"
          center
          show-icon
          :closable="false"
        >
        </el-alert>
      </el-card>
    </div>
    <!-- 选择门店弹窗 -->
    <div class="outlet">
      <el-dialog
        :close-on-click-modal="false"
        width="30%"
        :visible.sync="outletVisible"
        title="选择门店"
      >
        <el-form size="mini" label-width="90px">
          <el-row
            :gutter="50"
            v-for="(item, index) in StoreSelectionList"
            :key="index"
          >
            <el-col :span="12" v-for="(myitem, myindex) in item" :key="myindex">
              <el-tree
                ref="tree"
                v-if="myitem != undefined"
                :data="[myitem]"
                show-checkbox
                node-key="shopID"
                highlight-current
                default-expand-all
                :default-checked-keys="xuanzhong"
                :props="defaultProps"
              >
              </el-tree>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="ComButtomStore">确 定</el-button>
          <el-button @click="outletVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 导出弹窗 -->
    <div class="exporttc">
      <el-dialog
        :close-on-click-modal="false"
        width="20%"
        title="导出会员开源开散记录"
        :visible.sync="exportShow"
      >
        <div style="height: 50px; font-size: 14px; font-weight: 700">
          <p>
            <i
              class="iconfont icon-jingshi"
              style="font-size: 28px; color: #f39b21"
            ></i>
            是否确定
            <span style="color: #ff0000">导出</span>会员开源开散记录?
          </p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="Export">确 定</el-button>
          <el-button @click="exportShow = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 下载弹窗 -->
    <el-dialog
      append-to-body
      width="50%"
      :visible.sync="downloadShow"
      title="下载文件"
    >
      <el-table
        size="small"
        class="table-style"
        border
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          background: '#FCFBF2',
          'text-align': 'center',
          color: '#6C6839',
          fontSize: '14px',
        }"
        :cell-style="{ 'text-align': 'center' }"
        ref="multipleTable"
        :data="downloadData"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <!-- v-loading="loading"
        v-el-table-infinite-scroll="load"
        infinite-scroll-disabled="onLoading" -->
        <el-table-column type="index" width="55"></el-table-column>
        <el-table-column
          prop="startTime"
          label="开始执行时间"
        ></el-table-column>

        <el-table-column prop="endTime" label="结束执行时间"></el-table-column>

        <el-table-column prop="fileName" label="文件名"></el-table-column>

        <el-table-column prop="isComplate" label="状态">
          <template slot-scope="scope">
            {{ scope.row.isComplate ? "完成" : "执行中" }}
          </template>
        </el-table-column>
        <el-table-column prop="startTime" label="下载">
          <template slot-scope="scope">
            <el-button
              icon="el-icon-download"
              v-if="scope.row.isComplate"
              @click="download(scope.row.downloadUrl)"
              >下载</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  //   SysempRolepageApi,
  //   SysempRolequeryApi,
  //   SysempRolequerylimitsqxApi,
  customerDisperseDetailApi,
  customerDisperseStaticsApi,
  RegionApi,
  customerDisperseExportApi,
  reportFormList,
} from "@/api/reportForm";
import { dateTimes } from "@/utils/auth";
export default {
  name: "Memberopensource",
  data() {
    return {
      downloadData: [],
      downloadShow: false,
      exportShow: false,
      yearstable: [],
      yearstable1: [],
      // cntAll: "", // 总记录数
      // cntAllKS: "", // 总开散人数
      // cntAllKY: "", // 总开源人数
      queryInfojl: {
        cntAll: "",
        cntAllKS: "",
        cntAllKY: "",
      },
      // 选择门店数据
      xuanzhong: [],
      StoreSelectionList: [],
      StoredataArray: [],
      StoreSelectLength: 0,
      defaultProps: {
        children: "chlidren",
        label: "lable",
      },

      outletVisible: false,
      jurisdiction: {
        search: false,
        export: false,
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      // 首页radio
      radio: "",
      // 首页radio选中获取数据
      radioValuesjList: [],
      // 首页列表内容
      ActionroleqxList: [],
      // 首页列表请求参数
      queryInfo: {
        regionIds: [], // 区域
        listOfSomeStoreslStr: "", // 门店
        listOfSomeStoresl: [],
        shopIds: [],
        timeUnit: "1", // 年 月
        datePicker: [],
        beginDate: "", // 开始时间
        endDate: "", // 结束时间
        pageNum: 1, //页码
        pageSize: 50, //页数据
        pages: 0, //页总数据
      },
      regionList: [],
      // 首页loading
      loading: false,
      bodyStyle: {
        padding: "0px",
      },
    };
  },
  created() {
    this.moren();
    this.customerDisperseDetailList();
    this.ShopqueryRegionList();
    this.regionSelectList();
    let Memberopensource = JSON.parse(localStorage.getItem("Memberopensource"));
    for (let i = 0; i < Memberopensource.length; i++) {
      if (Memberopensource[i].menuName == "查询") {
        this.jurisdiction.search = true;
        continue;
      }
      if (Memberopensource[i].menuName == "导出") {
        this.jurisdiction.export = true;
        continue;
      }
    }
    console.log(Memberopensource);
  },
  computed: {
    isMore() {
      //当起始页数等于总页数时停止加载
      return this.queryInfo.pageNum >= this.queryInfo.pages;
    },
    onLoading() {
      return this.loading || this.isMore;
    },
  },
  methods: {
    //获取下载列表数据
    getDownladList() {
      reportFormList({
        groupName: "开源开散",
      }).then((response) => {
        console.log(response);
        this.downloadData = response.data;
      });
    },
    download(src) {
      this.exportShow = false;
      const ele = document.createElement("a");
      ele.style.display = "none";
      ele.href = src;
      ele.download = "";
      document.querySelectorAll("body")[0].appendChild(ele);
      ele.click();
      ele.remove();
    },
    // 数字千分位格式化
    toThousands(num) {
      num = num + "";
      return num.replace(/\d+/, function (n) {
        return n.replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
      });
    },
    // 默认日期
    moren() {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      this.queryInfo.datePicker[0] = start;
      this.queryInfo.datePicker[1] = end;
      // picker.$emit("pick", [start, end]);
    },
    // 首页列表
    customerDisperseDetailList() {
      if (this.queryInfo.datePicker && this.queryInfo.datePicker.length > 0) {
        this.queryInfo.beginDate = dateTimes(this.queryInfo.datePicker[0]);
        this.queryInfo.endDate = dateTimes(this.queryInfo.datePicker[1]);
      } else {
        this.queryInfo.beginDate = "";
        this.queryInfo.endDate = "";
      }
      let shopID = [];
      if (this.queryInfo.listOfSomeStoresl.length > 0) {
        //
        this.queryInfo.listOfSomeStoresl.forEach((item) => {
          shopID.push(item.id);
        });
      }
      let data = {
        pageNum: this.queryInfo.pageNum, //页码
        pageSize: this.queryInfo.pageSize, //页数据
        pages: this.queryInfo.pages,
        regionIds: this.queryInfo.regionIds, // 区域
        timeUnit: this.queryInfo.timeUnit, // 年月
        beginDate: this.queryInfo.beginDate,
        endDate: this.queryInfo.endDate,
        shopIds: shopID, // 门店id
      };
      let data1 = {
        regionIds: this.queryInfo.regionIds, // 区域
        timeUnit: this.queryInfo.timeUnit, // 年月
        beginDate: this.queryInfo.beginDate,
        endDate: this.queryInfo.endDate,
        shopIds: shopID, // 门店id
      };
      this.yearstable1 = [];
      customerDisperseDetailApi(data).then((res) => {
        if (this.queryInfo.pageNum == 1) this.ActionroleqxList = [];
        this.ActionroleqxList = this.ActionroleqxList.concat(res.data.list);
        this.queryInfo.pages = res.data.pages;
        res.data.list[0].staticData.forEach((item) => {
          this.yearstable1.push(item.date);
        });
        this.yearstable = this.yearstable1;
        this.loading = false;
      });
      customerDisperseStaticsApi(data1).then((res) => {
        this.queryInfojl.cntAll = res.data.cntAll;
        this.queryInfojl.cntAllKS = res.data.cntAllKS;
        this.queryInfojl.cntAllKY = res.data.cntAllKY;
      });
    },
    load() {
      this.loading = true;
      setTimeout(() => {
        this.queryInfo.pageNum += 1;
        this.customerDisperseDetailList();
      }, 1000);
    },
    // 查询
    search() {
      this.queryInfo.pageNum=1;
      if (this.queryInfo.datePicker && this.queryInfo.datePicker.length > 0) {
        this.queryInfo.beginDate = dateTimes(this.queryInfo.datePicker[0]);
        this.queryInfo.endDate = dateTimes(this.queryInfo.datePicker[1]);
      } else {
        this.queryInfo.beginDate = "";
        this.queryInfo.endDate = "";
      }
      let shopID = [];
      if (this.queryInfo.listOfSomeStoresl.length > 0) {
        //
        this.queryInfo.listOfSomeStoresl.forEach((item) => {
          shopID.push(item.id);
        });
      }
      let data = {
        pageNum: this.queryInfo.pageNum, //页码
        pageSize: this.queryInfo.pageSize, //页数据
        pages: this.queryInfo.pages,
        regionIds: this.queryInfo.regionIds, // 区域
        timeUnit: this.queryInfo.timeUnit, // 年月
        beginDate: this.queryInfo.beginDate,
        endDate: this.queryInfo.endDate,
        shopIds: shopID, // 门店id
      };
      let data1 = {
        regionIds: this.queryInfo.regionIds, // 区域
        timeUnit: this.queryInfo.timeUnit, // 年月
        beginDate: this.queryInfo.beginDate,
        endDate: this.queryInfo.endDate,
        shopIds: shopID, // 门店id
      };
      this.yearstable1 = [];
      customerDisperseDetailApi(data).then((res) => {
        if (res.success !== true) {
          this.$message.error("查询列表失败!");
          return;
        } else {
          this.$message.success("查询列表成功!");
          this.ActionroleqxList = res.data.list;
          this.queryInfo.pages = res.data.pages;
          res.data.list[0].staticData.forEach((item) => {
            this.yearstable1.push(item.date);
            console.log(item);
          });
          this.yearstable = this.yearstable1;
          // 动态表格 进行表格重置
          this.$nextTick(() => {
            this.$refs.multipleTable.doLayout();
          });
        }
      });
      customerDisperseStaticsApi(data1).then((res) => {
        this.queryInfojl.cntAll = res.data.cntAll;
        this.queryInfojl.cntAllKS = res.data.cntAllKS;
        this.queryInfojl.cntAllKY = res.data.cntAllKY;
      });
    },
    // 清除查询条件
    eliminate() {
      this.queryInfo = {
        regionIds: [], // 区域
        listOfSomeStoreslStr: "", // 门店
        listOfSomeStoresl: [],
        shopIds: [],
        timeUnit: "1", // 年 月
        datePicker: [],
        beginDate: "", // 开始时间
        endDate: "", // 结束时间
        pageNum: 1, //页码
        pageSize: 50, //页数据
        pages: 0, //页总数据
      };
      this.ActionroleqxList = [];
      this.xuanzhong = [];
      this.moren();
      this.customerDisperseDetailList();
    },
    // 导出
    Export() {
      if (this.queryInfo.datePicker && this.queryInfo.datePicker.length > 0) {
        this.queryInfo.beginDate = dateTimes(this.queryInfo.datePicker[0]);
        this.queryInfo.endDate = dateTimes(this.queryInfo.datePicker[1]);
      } else {
        this.queryInfo.beginDate = "";
        this.queryInfo.endDate = "";
      }
      let shopID = [];
      if (this.queryInfo.listOfSomeStoresl.length > 0) {
        //
        this.queryInfo.listOfSomeStoresl.forEach((item) => {
          shopID.push(item.id);
        });
      }
      let data = {
        regionIds: this.queryInfo.regionIds, // 区域
        timeUnit: this.queryInfo.timeUnit, // 年月
        beginDate: this.queryInfo.beginDate,
        endDate: this.queryInfo.endDate,
        shopIds: shopID, // 门店id
      };
      customerDisperseExportApi(data).then(() => {
        this.exportShow = false;
        this.$message.success("导出成功请在下载列表查看");
      });
      // customerDisperseExportApi(data).then((res) => {
      //   let exportId = res.data.exportId;
      //   const loading = this.$loading({
      //     lock: true,
      //     text: "导出中，请等待",
      //     spinner: "el-icon-loading",
      //     background: "rgba(0, 0, 0, 0.5)",
      //   });
      //   let timer = setInterval(function () {
      //     //每5秒刷新一次图表
      //     //需要执行的代码写在这里
      //     reportFormList({
      //       exportId: exportId,
      //     }).then((response) => {
      //       console.log(response.data[0].isComplate);
      //       if (response.data[0].isComplate) {
      //         that.download(response.data[0].downloadUrl);
      //         clearInterval(timer);
      //         loading.close();
      //       }
      //       // downloadUrl
      //     });
      //   }, 5000);
      // });
    },
    // 统计
    // customerDisperseStaticsList(){
    //   if(this.queryInfo.datePicker && this.queryInfo.datePicker.length > 0) {
    //     this.queryInfo.beginDate = dateTimes(this.queryInfo.datePicker[0])
    //     this.queryInfo.endDate = dateTimes(this.queryInfo.datePicker[1])
    //   }else{
    //     this.queryInfo.beginDate = "";
    //     this.queryInfo.endDate = "";
    //   }
    //   let shopID = [];
    //   if(this.queryInfo.listOfSomeStoresl.length > 0){
    //     //
    //     this.queryInfo.listOfSomeStoresl.forEach((item) =>{
    //       shopID.push(item.id)
    //     })
    //   }
    //   let data = {
    //     pageNo:this.queryInfo.pageNo, //页码
    //     pageSize:this.queryInfo.pageSize, //页数据
    //     pages:this.queryInfo.pages,
    //     regionIds:this.queryInfo.regionIds, // 区域
    //     timeUnit:this.queryInfo.timeUnit, // 年月
    //     beginDate:this.queryInfo.beginDate,
    //     endDate:this.queryInfo.endDate,
    //     shopIds:shopID,// 门店id
    //   }
    //   customerDisperseStaticsApi(data).then((res) =>{
    //     this.cntAll = res.data.cntAll
    //     this.cntAllKS = res.data.cntAllKS
    //     this.cntAllKY = res.data.cntAllKY
    //   })
    // },
    //   区域
    regionSelectList() {
      RegionApi({ regionID: "" }).then((res) => {
        if (res.success) {
          this.regionList.push({
            id: "",
            lable: "全部区域",
          });
          this.regionList.push(...res.data);
        }
      });
    },
    // 选择门店
    xuanzemendian() {
      this.outletVisible = true;
    },
    // 获取区域门店
    ShopqueryRegionList() {
      RegionApi().then((res) => {
        let arr1 = [],
          arr2 = [];
        if (res.success) {
          res.data.forEach((item) => {
            if (item.chlidren.length > 0) this.StoredataArray.push(item);
          });
          this.StoredataArray.forEach((item, index) => {
            item.chlidren.forEach((item) => {
              item.shopID = item.id;
            });
            this.StoreSelectLength += 1;
            if (index % 2 == 0) {
              arr1.push(item);
            } else {
              arr2.push(item);
            }
          });
          this.StoreSelectionList = arr1.map((key, value) => [
            key,
            arr2[value],
          ]);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 选择门店
    ComButtomStore() {
      //获取已选择的门店数据
      this.queryInfo.listOfSomeStoresl = [];
      this.queryInfo.listOfSomeStoreslStr = "";
      for (let index = 0; index < this.StoreSelectLength; index++) {
        let item = this.$refs.tree[index].getCheckedNodes();
        if (item.length == this.StoredataArray[index].chlidren.length + 1) {
          this.queryInfo.listOfSomeStoresl.push(
            ...this.StoredataArray[index].chlidren
          );
        } else {
          this.queryInfo.listOfSomeStoresl.push(...item);
        }
      }
      this.queryInfo.listOfSomeStoresl.forEach((item) => {
        this.queryInfo.listOfSomeStoreslStr += `${item.lable}\n`;
      });
      // this.queryInfo.listOfSomeStoreslStr =
      //   this.queryInfo.listOfSomeStoreslStr.substring(
      //     0,
      //     this.queryInfo.listOfSomeStoreslStr.length - 1
      //   );
      console.log(this.queryInfo.listOfSomeStoreslStr.length);
      this.xuanzhong = [];
      for (let i = 0; i < this.queryInfo.listOfSomeStoresl.length; i++) {
        this.xuanzhong.push(this.queryInfo.listOfSomeStoresl[i].id);
      }
      // console.log(this.xuanzhong);
      this.outletVisible = false;
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
  },
};
</script>
<style lang="scss" scoped>
.JfNumber-flex {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.demo-input-suffix {
  display: flex;
  align-content: center;
  justify-content: space-around;
  height: 25px;
  margin-top: 15px;
  margin-bottom: 15px;
}
.integrate-number {
  margin-left: 20px;
  height: 40px;
  /* background: #f5f5f5; */
  border: 1px solid #cccccc;
  width: 100px;
  text-align: center;
  line-height: 40px;
}
.btn1 {
  width: 12%;
  /* margin-top: 100px; */
}

#alterations {
  height: 100%;
}
.header-text {
  height: 50px;
  margin-top: 20px;
  color: #76734f;
}
.searchform {
  margin-top: 20px;
}
.centercard {
  margin-top: 10px;
}
.card-pagination {
  margin-top: 20px;
  text-align: right;
}
// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}
/deep/input {
  border-radius: 0 !important;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}

// 选择门店弹框样式
/deep/.outlet {
  .el-dialog__header {
    background-color: #f3f1dd;
  }
  .el-dialog__title {
    font-size: 14px;
    font-weight: 700;
    color: #6c6937;
  }
  .el-dialog__body {
    padding: 20px 10px 20px 10px;
  }
  .el-dialog__footer {
    height: 60px;
    text-align: center;
    background-color: #f2f2f2;
  }
  .el-button:hover {
    background-color: #b5b386;
    color: #f2f2f2;
  }
}
/deep/.el-dialog__header {
  padding: 1.25rem 1.25rem 0.625rem;
  background-color: #d1cda5;
}
.el-table .warning-row {
  background: #fcfbf2;
}
.el-table .success-row {
  background: #ffffff;
}
::v-deep {
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 改变table里的按钮图标大小
  .table-button .iconfont {
    font-size: 14px;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }

  // 设置表单里字体的颜色
  .el-form-item__label {
    color: #76734f;
  }
  // 导出弹框样式
  .exporttc {
    .el-dialog__header,
    .el-message-box__header {
      border-top-left-radius: 9px;
      border-top-right-radius: 9px;
      height: 44px;
      background: #f3f1dd;
      width: 100%;
      text-align: center;
      color: #666;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      box-sizing: border-box;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 16px !important;
    }
    .el-dialog .el-dialog__body {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .coverage-release .el-dialog__body {
      padding: 20px;
    }
    .el-button:hover {
      background-color: #b6b388;
    }
    .el-dialog__body {
      padding: 30px 60px;
    }
    .el-tabs__item {
      border: 1px solid #d9d9d9;
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-tabs__item.is-active {
      color: #6c6937;
      background-color: #f3f1dd;
    }
    .el-form-item__content {
      line-height: 0px;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
}
</style>
